import PropTypes from 'prop-types';
import React from 'react';

import { FormControlLabelStyled } from './TrlFormControlLabel.styles';

export const TrlFormControlLabel = ({
  id,
  label,
  selectedOptionId,
  children,
}) => (
  <FormControlLabelStyled
    value={id}
    checked={selectedOptionId && id === selectedOptionId}
    control={children}
    label={label}
    labelPlacement="start"
  />
);

TrlFormControlLabel.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  selectedOptionId: PropTypes.string,
  children: PropTypes.element,
};
